import React from 'react';

const DefaultWindow = () => {
  return <div className="default-window"></div>;
};

export default DefaultWindow;
